import React from "react";
import {
  Link,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Box,
  useTheme,
} from "@material-ui/core";


export default function DisableConfirmationModal({
  handleClose,
  handleAccept,
}: {
  handleClose: () => void,
  handleAccept: () => void,
}) {
  const theme = useTheme();

  return (
    <div>
      <Dialog open onClose={handleClose}>
        <DialogTitle>Отключить канал?</DialogTitle>
        <DialogContent
          dividers
          style={{
            paddingBottom: theme.spacing(1),
            color: "#323232",
          }}
        >
          <Box mb={2}>
            Вы уверены, что хотите отключить канал?
          </Box>

          <Box mb={2}>
            Если это единственный подключенный канал для уведомлений, они перестанут отправляться.
          </Box>
        </DialogContent>
        <DialogActions>
          <Box
            display="flex"
            flexDirection="row"
            width="100%"
            paddingX={2}
            paddingY={1}
          >
            <Box width="50%">
              <Button
                onClick={handleClose}
                variant="contained"
                style={{
                  paddingLeft: theme.spacing(3),
                  paddingRight: theme.spacing(3),
                }}
              >
                Отмена
              </Button>
            </Box>
            <Box width="50%" textAlign="right">
              <Button
                onClick={handleAccept}
                variant="contained"
                style={{
                  paddingLeft: theme.spacing(3),
                  paddingRight: theme.spacing(3),
                  backgroundColor: "white",
                  color: "#F45858",
                }}
              >
                Подтвердить отключение
              </Button>
            </Box>
          </Box>
        </DialogActions>
      </Dialog>
    </div>
  );
}
